module.exports = __webpack_public_path__ + "static/media/close.6708f998.png";